<template>
  <div class="home-lobby">
    <header class="sr-only">
      <h1>Spinx888 — online slots, fishing games, Shan Koe Mee, Bugyi, live casino and card games</h1>
    </header>
    <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
    <!-- <div class="col-12 d-flex my-0">
      <img
        class="mx-auto"
        src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
        alt=""
        style="width: 120px; height: 120px; margin-top: -22px"
      />
    </div> -->

    <Sticky>
      <div>
        <NavBar />
        <div class="col-12 w-100 px-0 mx-0 d-flex main-image-wrapper home-banner">
          <b-carousel
            id="carousel-1"
            :interval="3000"
            controls
            fade
            class="home-banner__carousel w-100"
            style="width: 100%; height: 100%;"
          >
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/spin888/cards/BN%20CB.webp"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/spin888/cards/BN10.webp"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/spin888/cards/BN200.webp"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/spin888/cards/BN50.webp"></b-carousel-slide>
          </b-carousel>
        </div>

        <div
          class="col-12 d-flex px-0 px-3 mx-auto my-2"
          style="z-index: 10; padding-top: 2px; padding-bottom: 2px; background: radial-gradient(circle, #3b82f6 0%, #1e3a8a 50%, #0f172a 100%) !important;"
        >
          <i
            class="fas fa-volume-up my-auto text-white pr-3"
            style="font-size: 14px; font-weight: 600;"
          ></i>
          <NoticeBar
            class="col-lg-12 col-12 mx-0 px-0 mx-auto notice-bar"
            scrollable
            :text="websiteInfo.noticeText"
            v-if="!threedData.embedded_link && !threedData.isLive"
          />
          <!-- websiteInfo[0]?.noticeText  -->
        </div>

        <!-- <div class="my-3 text-center py-2" style="background: #F4DC83; font-weight: 900; color: black;">
          TOP GAMES
        </div> -->
      </div>
    </Sticky>


    <div class="cards-container-mobile">
      <div
        class="container-fluid justify-content-end px-0 d-flex pt-0"
        style="position: relative;"
      >
        <!-- <div class="col-12"> -->

        <div
          class="pr-0 mx-0 pl-2 index_left sidebar"
          style="overflow-y: auto; margin-bottom: 25rem; height: 90vh; width: 20%; position: absolute;"
        >
          <div style="height: 130vh;">
            <ul class="nav nav-pills game-nav">
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon home-nav-chip d-flex flex-column p-2"
                  :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                  style="padding-top: 0.6rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('hot');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/spin888/icons/HOT%20BT.webp"
                    class="mx-auto p-0 m-0 pr-1"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <span
                    class="mt-1 mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                  >{{ $t('home.hot') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                  :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                  style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('buffalo');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/spin888/icons/BF%20BT.webp"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <!-- <img v-show="$store.state.sideNav === 'buffalo'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0c75648c-b244-4972-a288-6e11ca52f100/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                  >{{ $t('home.buffalo') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                  :class="$store.state.sideNav === 'card' ? 'active' : ''"
                  style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('card');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/spin888/icons/CARD%20BT.webp"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <!-- <img v-show="$store.state.sideNav === 'card'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0c75648c-b244-4972-a288-6e11ca52f100/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'card' ? 'active' : ''"
                  >{{ $t('home.card') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon home-nav-chip d-flex flex-column p-2"
                  :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                  style="padding-top: 0.6rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('slot');"
                >
                  <!-- <img v-show="$store.state.sideNav !== 'slot'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/75b1ab42-51bc-408a-56cd-85ec16303d00/public" class="mx-auto p-0 ml-2" style="cursor: pointer; width: 3rem;"> -->
                  <img
                    src="https://storage.googleapis.com/spacetech2/spin888/icons/SLOT%20BT.webp"
                    class="mx-auto p-0 ml-2 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                  >{{ $t('home.slot') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon home-nav-chip d-flex flex-column p-2"
                  :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                  style="padding-top: 1rem !important;width: 90%; height: 6rem; border-radius: 10px;"
                  @click="changeSideNav('fishing');"
                >
                  <!-- <img v-show="$store.state.sideNav !== 'fishing'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/1c9d8b71-8e10-4dbc-a3f4-6eb1b6631b00/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                  <img
                    src="https://storage.googleapis.com/spacetech2/spin888/icons/FISH%20BT.webp"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <span
                    class="mt-1 mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                  >{{ $t('home.fishing') }}</span>
                </div>
              </li>
              <!-- <li class="nav-item d-flex mt-2">
                    <div class="side-nav-icon d-flex flex-column p-2 pt-0" :class="$store.state.sideNav === 'football' ? 'active': ''" style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;" @click="changeSideNav('football');">
                      <img src="https://storage.googleapis.com/spacetech2/abc777/icon%207.webp" class="mx-auto p-0 m-0 pulse" style="cursor: pointer; width: 3rem;">
                      <span class="mx-auto side-nav-icon-text" :class="$store.state.sideNav === 'football' ? 'active': ''">{{$t('home.football')}}</span>
                    </div>
                  </li> -->
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon home-nav-chip d-flex flex-column p-2 pt-0"
                  :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                  style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('casino');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/spin888/icons/CASINO%20BT.webp"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 3rem;"
                  >
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                  >{{ $t('home.casino') }}</span>
                </div>
              </li>

              <!-- <li class="nav-item d-flex mt-2">
                    <div class="side-nav-icon d-flex flex-column p-2 pt-0" :class="$store.state.sideNav === 'download' ? 'active': ''" style="padding-top: 0.8rem !important; width: 90%; height: 5rem; border-radius: 10px;" @click="changeSideNav('download');">
                      <img v-show="$store.state.sideNav !== 'download'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/cd795506-1111-41aa-135a-561223d42600/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 2rem;">
                      <img v-show="$store.state.sideNav === 'download'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/cd795506-1111-41aa-135a-561223d42600/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 2rem;">
                      <span class="mx-auto side-nav-icon-text" :class="$store.state.sideNav === 'download' ? 'active': ''">{{$t('home.download')}}</span>
                    </div>
                  </li> -->
            </ul>
          </div>
        </div>

        <div
          class="index_rightbar mr-0 pl-0 col-10 pl-2 pr-1"
          id="index_rightbar"
          style="height: 90vh; overflow-y: scroll; position: absolute;"
        >
          <div :style="($store.state.sideNav === 'hot') ? 'height: 400vh' : 'height: 150vh'">
            <div
              class="tab-content game home-game-panel px-2"
              style="min-height: 50vh; border-radius: 20px; height: auto; padding-bottom: 30rem;"
            >

              <div
                class="mx-1 mt-0"
                :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                v-show="$store.state.sideNav === 'hot'"
              >
                <div>
                  <section class="home-section col-12 p-0 py-2">
                    <h2 class="home-section__title">{{ $t('home.popular_slot_games') }}</h2>
                    <div class="home-game-grid">
                      <button
                        v-for="slotGame in hotGames['slotGames']"
                        :key="slotGame.id"
                        type="button"
                        class="home-game-tile"
                        @click="gameInit(slotGame)"
                      >
                        <span
                          class="home-game-tile__hot"
                          aria-hidden="true"
                        >
                          <img
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt=""
                          >
                        </span>
                        <div class="home-game-tile__thumb">
                          <img
                            :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                            :alt="slotGame.name || 'Game'"
                            loading="lazy"
                          />
                        </div>
                        <span class="home-game-tile__name">{{ slotGame.name }}</span>
                      </button>
                    </div>
                  </section>

                  <section class="home-section col-12 p-0 py-1">
                    <h2 class="home-section__title">{{ $t('home.popular_fishing_games') }}</h2>
                    <div class="home-game-grid">
                      <button
                        v-for="slotGame in hotGames['fishingGames']"
                        :key="slotGame.id"
                        type="button"
                        class="home-game-tile"
                        @click="(slotGame.provider === 'PGSoft' || slotGame.provider === 'FaChai') ? showAlertBox(slotGame) : gameInit(slotGame)"
                      >
                        <span
                          class="home-game-tile__hot"
                          aria-hidden="true"
                        >
                          <img
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt=""
                          >
                        </span>
                        <div class="home-game-tile__thumb">
                          <img
                            :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                            :alt="slotGame.name || 'Game'"
                            loading="lazy"
                          />
                        </div>
                        <span class="home-game-tile__name">{{ slotGame.name }}</span>
                      </button>
                    </div>
                  </section>

                  <section class="home-section col-12 p-0 py-1">
                    <h2 class="home-section__title">{{ $t('home.popular_arcade_games') }}</h2>
                    <div class="home-game-grid">
                      <button
                        v-for="slotGame in hotGames['arcadeGames']"
                        :key="slotGame.id"
                        type="button"
                        class="home-game-tile"
                        @click="(slotGame.provider === 'PGSoft' || slotGame.provider === 'FaChai') ? showAlertBox(slotGame) : gameInit(slotGame)"
                      >
                        <span
                          class="home-game-tile__hot"
                          aria-hidden="true"
                        >
                          <img
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt=""
                          >
                        </span>
                        <div class="home-game-tile__thumb">
                          <img
                            :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                            :alt="slotGame.name || 'Game'"
                            loading="lazy"
                          />
                        </div>
                        <span class="home-game-tile__name">{{ slotGame.name }}</span>
                      </button>
                    </div>
                  </section>
                </div>
              </div>



              <!-- <div class="mx-1" :class="this.$store.state.sideNav === 'vs' ? 'active' : ''" v-show="this.$store.state.sideNav === 'vs'">
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/723ca88a-6cf0-406b-d7b3-a93d023f6f00/public" alt="slot" style="cursor: pointer; width: 103%; margin-left: -0.4rem; height: auto;" @click="gameInit('CockFight')">
                  </div> -->

              <div
                :class="$store.state.sideNav === 'skm' ? 'active' : ''"
                v-if="$store.state.sideNav === 'skm'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(0)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(1)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(2)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(3)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(4)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(5)"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'bgy' ? 'active' : ''"
                v-if="$store.state.sideNav === 'bgy'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(0)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(1)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(2)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(3)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(4)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(5)"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'card' ? 'active' : ''"
                v-if="$store.state.sideNav === 'card'"
                class="pb-2 mx-0 px-0 d-flex flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/SKM%20IC.webp"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="changeSideNav('skm')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/BG%20IC.webp"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="changeSideNav('bgy')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/SP%20IC.webp"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="fetchForestData()"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/GL%20IC.webp"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="fetchGaloneData()"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                v-if="$store.state.sideNav === 'buffalo'"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/BF%20IC.webp"
                  alt="skm"
                  class="px-0 mx-0"
                  style="cursor: pointer; width: 100%; height: auto;"
                  @click="$router.push('/user/slots?provider=Buffalo')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                v-if="$store.state.sideNav === 'fishing'"
                class="home-provider-grid pb-2 mx-0 px-0 d-flex flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/FC%20FH%20IC.webp"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=FaChai')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/JILI%20FH%20IC.webp"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=Jili')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/2J%20FH%20IC.webp"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=2J')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/JDB%20FH%20IC.webp"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=Spade')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/R88%20FS%20IC.webp"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=Rich88')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/BT%20FH%20IC.webp"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0 home-provider-banner"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=BTG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/AW%20FH%20IC.webp"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=JDB')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/ka%20fish.webp"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=KA')"
                >

              </div>

              <div
                :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                v-if="$store.state.sideNav === 'slot'"
                class="home-provider-grid pb-2 mx-0 px-0 d-flex flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/PP%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Pragmatic')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/PG-Slot.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=PGSoft')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/JILI%20IC%20(1).webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Jili')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/2J%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=2J')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/JDB%20IC%20(1).webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=JDB')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/BNG%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=BNG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/LIVE22%20IC%20(1).webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Live22')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/VA%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=VA')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/FC%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=FaChai')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/HD%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=HotDog')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/AW%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=AceWin')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/BT%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=BTG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/PS%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Playstar')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/5G%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=5G')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/RICH%20IC%20(1).webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Rich')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/R88%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Rich88')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/KA%20IC.webp"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=KA')"
                >

              </div>

              <div
                :class="$store.state.sideNav === 'football' ? 'active' : ''"
                v-if="$store.state.sideNav === 'football'"
                class="home-provider-grid pb-2 mx-0 px-0 d-flex flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/abc777/Football%201.webp"
                  alt="Body football"
                  class="col-6 my-2 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/body-fb')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/abc777/Football%202.webp"
                  alt="Maung football"
                  class="col-6 my-2 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/maung-fb')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/abc777/Football%203.webp"
                  alt="Live football"
                  class="col-6 my-2 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/live')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/abc777/Football%204.webp"
                  alt="Match results"
                  class="col-6 my-2 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/football-result')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/abc777/Football%205.webp"
                  alt="Betslip history"
                  class="col-6 my-2 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/betslip-history')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                v-if="$store.state.sideNav === 'casino'"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/spin888/cards/PP%20CS%20IC.webp"
                  alt="casino"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 100%; height: auto;"
                  @click="gameInitCasino('PP Live')"
                >
                <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/Sexy%20Live%20copy.png" alt="casino" class="my-2 px-0 mx-0" style="cursor: pointer; width: 100%; height: auto;" @click="gameInitCasino('Sexy')">
                    <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/wm%20casino%20copy.png" alt="casino" class="my-2 px-0 mx-0" style="cursor: pointer; width: 100%; height: auto;" @click="gameInitCasino('WM')">
                    <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/BG%20Casino%20copy.png" alt="skm" class="my-2 px-0 mx-0" style="cursor: pointer; width: 100%; height: auto;" @click="gameInitCasino('BG')"> -->
              </div>

              <div
                :class="$store.state.sideNav === 'download' ? 'active' : ''"
                v-if="$store.state.sideNav === 'download'"
              >
                <div class="gwrap_1 pb-3">
                  <h4 class="text-center text-dark mt-3">{{ $t('home.you_download') }} <br> {{ $t('home.on_any_platform') }}
                  </h4>
                  <a
                    href="https://backapi.melonzeed.vip/api/app/download/android"
                    download="melonzeed.apk"
                  >
                    <img
                      src="https://cdn.gold549.com/build/assets/img/brand/android-download.png"
                      alt="slot"
                      style="cursor: pointer; width: 50%; height: auto;"
                    >
                  </a>
                  <a
                    href="https://backapi.melonzeed.vip/api/app/download/ios"
                    download="melonzeed.mobileconfig"
                  >
                    <img
                      src="https://cdn.gold549.com/build/assets/img/brand/ios-download.png"
                      alt="slot"
                      style="cursor: pointer; width: 50%; height: auto; margin-top: 0.1rem;"
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>


    <van-overlay :show="isLoading">
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#ffffff"
          class="mx-auto"
        />
      </div>
    </van-overlay>

    <!-- <LiveChatWidget license="18638211" v-if="testing"/> -->

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        style="z-index: 100000 !important;"
        @click="hideLimit()"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div
            class="modal-content"
            style="z-index: 200000 !important;"
          >
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br><br>

                {{ isLoading }}
              </span>
              <span>{{ limitText }}</span>
              <br><br> <span class="text-dark text-sm">
                <button
                  class="btn btn-danger"
                  @click="gameInit(desiredGame)"
                >
                  {{
                    $store.state.language === "en"
                      ? "Play The Game"
                      : "ဂိမ်းဆော့မည်။"
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import NavBar from '@/layouts/NavBar.vue';
import { NoticeBar, Dialog, Toast, Sticky } from 'vant';
import { mapActions } from 'vuex';
import { openGameInIframe } from '@/libs/openGameInIframe';
import { LiveChatWidget } from '@livechat/widget-vue';

export default {
  components: { NoticeBar, Sticky, LiveChatWidget },
  data() {
    return {
      testing: true,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {
        home_banners: {}
      },
      isLogged: false,
      hotGames: {
        slotGames: [],
        fishingGames: [],
        arcadeGames: [],
      },
      limitText: '',
      desiredGame: null,
    };
  },
  destroyed() {
    this.testing = false;
  },
  methods: {
    async fetchForestData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/forest-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          openGameInIframe(this.$router, this.$store, res.data.data.gameUrl);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/galone-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          openGameInIframe(this.$router, this.$store, res.data.data.gameUrl);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    hideLimit() {
      $('#limit').modal('hide');
    },
    showAlertBox(game) {
      if (game.provider === 'PGSoft') this.limitText = 'PG Soft တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။';
      else if (game.provider === 'FaChai') this.limitText = 'FaChai Provider တွင် 1 unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      // else this.limitText = '5G Provider တွင် 1K unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      $('#limit').modal('show');
      this.desiredGame = game;
    },

    async gameInit(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: game.provider
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          openGameInIframe(this.$router, this.$store, res.data.data.gameUrl);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },

    async gameInitCasino(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            provider: game,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          openGameInIframe(this.$router, this.$store, res.data.data.gameUrl);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },

    imageLinkGenerate(gameId, type) {
      if (type === 'Jili') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
      } if (type === 'Live22') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
      } if (type === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Playstar') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
      } if (type === 'FaChai') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
      } if (type === 'PGSoft') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
      } if (type === 'JOKER' || type === 'Joker') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
      } if (type === '5G') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
      } if (type === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
      } if (type === 'AceWin') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
      } if (type === 'JDB') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
      } if (type === 'Buffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
      } if (type === 'HotDog') {
        return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
      } if (type === 'Rich') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
      } if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
      } if (type === 'BTG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
      } if (type === '2J') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
      } if (type === 'VA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
      } if (type === 'BNG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
      } if (type === 'AfricanBuffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
      }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
    },
    scrollToElement() {
      const container = this.$el.querySelector('.index_rightbar');
      // Scroll to the target element within the container
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game
          this.gameLink = link
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          }
        });
        openGameInIframe(this.$router, this.$store, `https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`)
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async fetchBugyee(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        const res = await axios.get('/bugyee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        // this.$store.commit('setIframeURL', res.data.data.gameUrl);
        // this.$router.push('/iframeURL');

        if (res.data?.data?.gameUrl) {
          openGameInIframe(this.$router, this.$store, res.data.data.gameUrl);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },

    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          // $('#limit').modal('show');
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          Dialog.alert({
            message: this.limitText,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get('/shankomee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (res.data?.data?.gameUrl) {
          openGameInIframe(this.$router, this.$store, res.data.data.gameUrl);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },
    // async gameInit(game) {
    //   try {
    //     this.isLoading = true;
    //     const authUser = await this.fetchUser();
    //     if (!authUser) {
    //       this.$router.push('/auth/login');
    //     }

    //     const res = await axios.get('/games/url', {
    //       params: {
    //         provider: game
    //       },
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('token')}`,
    //       },
    //     });

    //     window.open(res.data.data.gameUrl, "_self");
    //     // this.$store.commit('setIframeURL', res.data.data.gameUrl);
    //     // this.$store.commit('setIsCardGame', false);
    //     // this.$router.push('/iframeURL');

    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //     // this.$router.go();
    //   }
    // },
    changeSideNav(para) {
      // this.sideNav = para;
      this.$store.commit('updateSideNav', para);
      this.scrollToElement()
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    async redirectRoute(path, query = null) {
      try {
        console.log('query', query)
        if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === 'tip') {
          const text = this.$store.state.language === 'en'
            ? 'This feature is not support yet.'
            : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === 'en'
                ? 'Okay'
                : 'Okay',
          }).then(() => {
            // on close
          });
        } else if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHotGames() {
      try {
        const res = await axios.get('/hot-games');
        this.hotGames = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        const threeDres = await axios.get('/threed_history');
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Function to load the Tawt.io chat widget
    // loadTawkChat() {
    //   console.log('here1')
    //   if (!document.getElementById('tawk-io-chat')) {
    //     console.log('here2')
    //     var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();

    //     // Dynamically add the script to load Tawt.io
    //     var s1 = document.createElement("script");
    //     var s0 = document.getElementsByTagName("script")[0];
    //     s1.async = true;
    //     s1.id = 'tawk-io-chat';
    //     s1.src = 'https://embed.tawk.to/66ed95584cbc4814f7dc1919/1i880up29';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);

    //     // Apply custom styles when the widget loads
    //     Tawk_API.onLoad = () => {
    //       this.applyCustomStyles();
    //       setInterval(this.applyCustomStyles, 1000);
    //     };
    //   }
    // },
    // Function to apply custom styles to the Tawk.to iframe
    applyCustomStyles() {
      var tawkIframe = document.querySelector('iframe[title="chat widget"]');
      if (tawkIframe) {
        tawkIframe.style.bottom = '7rem'; // Adjust this as needed
        tawkIframe.style.left = '1rem';
        tawkIframe.style.right = '0rem';
      }
    },
    // Function to remove the Tawt.io script and widget
    removeTawkChat() {
      const tawkScript = document.getElementById('tawk-io-chat');
      if (tawkScript) {
        tawkScript.remove(); // Remove the script tag
      }

      // Remove the Tawk.to iframe widget
      const tawkIframe = document.querySelector('iframe[title="chat widget"]');
      if (tawkIframe) {
        tawkIframe.remove();
      }
    }
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    await this.fetchWebsiteData();
    await this.fetchHotGames();
    this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    this.removeTawkChat();
  }
};
</script>
<style scoped>
/* —— Clean game lobby (blue accent, minimal noise) —— */
.home-lobby {
  min-height: 100vh;
  padding-bottom: 15rem;
  background: linear-gradient(180deg, #fff1f2 0%, #ffffff 26%, #f8fafc 100%);
  background-attachment: fixed;
}

/* Full-bleed banner: no strong tint behind slides (fade / letterboxing) */
.home-banner {
  max-width: 100%;
  overflow: hidden;
  background: #fff;
}

.home-banner ::v-deep .carousel,
.home-banner ::v-deep .carousel-inner,
.home-banner ::v-deep .carousel-item {
  background: #fff !important;
  border-radius: 0 !important;
}

.home-banner ::v-deep .carousel-item img,
.home-banner ::v-deep img {
  border-radius: 0 !important;
}

.home-game-panel {
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  /* border: 1px solid #e2e8f0; */
  box-shadow: none;
}

.home-section {
  margin-bottom: 0.15rem;
}

.home-section__title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1e3a8a;
  margin: 0 0 12px;
  padding: 0 0 8px 0;
  border-left: none;
  border-bottom: 1px solid #e2e8f0;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.35;
}

.home-game-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.home-game-tile {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 14px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.15s ease;
  text-align: center;
}

.home-game-tile:active {
  transform: scale(0.97);
}

.home-game-tile__thumb {
  border-radius: 12px;
  overflow: hidden;
  background: #f1f5f9;
  border: none;
  box-shadow: none;
  transition: transform 0.2s ease;
}

.home-game-tile:hover .home-game-tile__thumb,
.home-game-tile:focus-visible .home-game-tile__thumb {
  transform: translateY(-1px);
  box-shadow: none;
}

.home-game-tile:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.home-game-tile__thumb img {
  display: block;
  width: 100%;
  height: auto;
  min-height: 88px;
  object-fit: cover;
  aspect-ratio: 3 / 4;
}

.home-game-tile__hot {
  position: absolute;
  top: -8px;
  right: -4px;
  z-index: 2;
  width: 26px;
  pointer-events: none;
}

.home-game-tile__hot img {
  width: 100%;
  height: auto;
  display: block;
}

.home-game-tile__name {
  margin-top: 6px;
  font-size: 0.62rem;
  font-weight: 600;
  color: #334155;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding: 0 2px;
}

.home-nav-chip.side-nav-icon:not(.active) {
  background: #f8fafc !important;
  color: #1e293b !important;
  /* border: 1px solid #e2e8f0 !important; */
  box-shadow: none;
}

.home-nav-chip:not(.active) .side-nav-icon-text {
  color: #334155 !important;
}

.home-provider-grid img {
  border-radius: 14px;
  /* border: 1px solid #e2e8f0; */
  box-sizing: border-box;
  transition: transform 0.18s ease, border-color 0.18s ease;
  box-shadow: none;
}

.home-provider-grid img:hover {
  border-color: #93c5fd;
}

.home-provider-grid img:active {
  transform: scale(0.98);
}

.home-provider-banner {
  border-radius: 14px !important;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.side-nav-icon-text {
  /* color: #A80000; */
  font-size: 0.9rem;
  /* color: #382618; */
}

.side-nav-icon {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  font-weight: 600;
  color: black !important;
  box-shadow: none;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.side-nav-icon.active {
  border-color: transparent;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #2563eb 100%);
  color: white !important;
}

.side-nav-icon-text.active {
  color: white !important;
}

.sidebar {
  position: fixed;
  /* top: 23.5rem; */
  left: 0;
  height: 55vh;
  padding-bottom: 50px;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
  overflow-y: auto;
}

.index_rightbar {
  padding: 0px 10px;
  overflow-y: scroll;
  height: 55vh;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 1px solid #2563eb;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: #2563eb;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background-color: #2563eb;
  box-shadow: none;
  transform: none;
}

.detail-button:active {
  box-shadow: none;
  transform: none;
}

.nav-pills.game-nav {
  padding-right: 5px;
}

.nav-pills .nav-link {
  border-radius: 10px !important;
  margin-bottom: 5px;
  /* padding: 10px; */
  font-size: 10px !important;
  text-align: center;
  color: #ffffff;
  /* background: linear-gradient(#aa9ace, #714DC7); */
}

.nav-pills:not(.nav-pills-circle) .nav-item {
  padding-right: 0;
  margin-bottom: 0;
  width: 100px;
}

.nav-pills .nav-link img {
  width: 18px !important;
  /* margin-right: 10px; */
  padding-bottom: 4px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff !important;
  background: linear-gradient(#fff, #8a69d9);
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tab-content.game a img {
  /* box-shadow: 0px 3px 14px -5px rgba(0, 0, 0, 0.4); */
  border-radius: 21px;
  margin-bottom: 10px;
  width: 100%;
}

.tab-content.game {
  padding-left: 3px;
}

.tab-content>.tab-pane {
  display: none;
  padding-right: 3px;
}

.tab-content>.active {
  display: block;
}


.css-38745a {
  margin: 0px;
  line-height: 1.5;
  font-size: 12px;
  font-family: NotoSansMyanmar;
  font-weight: 500;
}

.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  font-family: NotoSansMyanmar;
  font-weight: 700 !important;
}

.card {
  cursor: pointer;
  border-radius: 10px !important;
}

.main-image-wrapper img {
  width: 100%;
  border-radius: 0 !important;
  display: block;
}

.video-container {
  height: 500px;
  width: 100%;
}

.notice-bar {
  margin-top: -40px;
  z-index: 1;
  font-size: 20px;
  color: rgb(255, 242, 135);
  background: transparent;
  border-radius: 0 !important;
}

.notice-bar ::v-deep .van-notice-bar {
  border-radius: 0 !important;
}

.twod-threed-cards {
  height: 200px;
}

.live-number {
  font-weight: bold;
  font-size: 25px;
}

.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.not-live-text {
  font-weight: bold;
  font-size: 24px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
}

.card-body {
  padding: 0px !important;
}

.cards-container-mobile {
  display: none;
}

@keyframes live-number-animation {
  from {
    color: white;
  }

  to {
    color: #2563eb;
  }
}

/* @media (max-width: 768px) { */
/* .middle-container {
    padding-top: 0.1rem !important;
  } */
hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.video-container {
  height: 300px;
  width: 100%;
}

.main-wrapper {
  padding: 7px !important;
}

.notice-bar {
  margin-top: 0px;
  height: 25px;
  z-index: 1;
  font-size: 12px;
  color: white;
  background: transparent;
  border-radius: 0 !important;
}

.live-number {
  font-weight: bold;
  font-size: 20px;
}

.live-result {
  font-weight: bolder;
  font-size: 37px;
}

.cards-container {
  display: none;
}

.cards-container-mobile {
  padding: 0px !important;
  margin-top: 5px !important;
  display: flex;
  flex-wrap: wrap;
}

.home-cards {
  padding-left: 10px;
  padding-right: 10px;
}

.card-body {
  padding: 0px !important;
}

.not-live-text {
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.account-container-wrapper {
  width: auto;
  height: auto;
  border-radius: 10px;
  padding-left: 4px;
  padding-right: 4px;
  margin-top: 10px !important;
  margin-left: 10px;
  margin-right: 10px;
  color: #000000;
  border: 1px solid #e2e8f0;
  box-shadow: none;
}

.top-wrapper,
.bottom-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
}

.top-right,
.bottom-right {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: end;
}

.top-left,
.bottom-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: start;
}

/* } */
</style>
